import { Header, Sidebar } from 'components/Global';
import { PermissionContext } from 'components/Global/AuthLayout';
import { FORMDATA } from 'constants/Data';
import { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';

const GlobalLayout = () => {
	// inits
	const { pageMenuItems } = FORMDATA;

	const { pathname } = useLocation();
	const [finalMenuItems, setFinalMenuItems] = useState<any>(pageMenuItems);
	const [isLoading] = useState(false);

	const permissionContext = useContext(PermissionContext);
	const navigate = useNavigate();

	useEffect(() => {
		let menuItems;
		if (permissionContext.isSuperAdmin) {
			menuItems = pageMenuItems;
		} else {
			const buildTimeActivitiesChildren = () => {
				const children = [];
				if (
					permissionContext.allowedPermissions.includes(
						'Allow_Time_Logs'
					)
				) {
					children.push({
						key: 'daily-attendance',
						label: 'Daily Attendance',
						icon: '',
					});
				}
				if (
					permissionContext.allowedPermissions.includes(
						'Allow_Time_Activities'
					)
				) {
					children.push({
						key: 'monthly-summary',
						label: 'Monthly Summary',
						icon: '',
					});
				}
				if (
					permissionContext.allowedPermissions.includes(
						'Allow_Employee_Mapping'
					)
				) {
					children.push({
						key: 'assign-supervisor',
						label: 'Assign Supervisor',
						icon: '',
					});
				}
				return children;
			};

			const buildRunPayrollChildren = () => {
				const children = [];
				if (
					permissionContext.allowedPermissions.includes(
						'Allow_Loan_Request'
					)
				) {
					children.push({
						key: 'loan-request',
						label: 'Loan Request',
						icon: '',
					});
				}
				if (
					permissionContext.allowedPermissions.includes(
						'Allow_Mid-Month_Pay'
					)
				) {
					children.push({
						key: 'mid-month',
						label: 'Mid Month Pay',
						icon: '',
					});
				}
				if (
					permissionContext.allowedPermissions.includes(
						'Allow_Run_Payroll'
					)
				) {
					children.push({
						key: 'payroll-overview',
						icon: '',
						label: 'Payroll Overview',
					});
				}
				if (
					permissionContext.allowedPermissions.includes(
						'Add_Run_Payroll'
					) ||
					permissionContext.allowedPermissions.includes(
						'Edit_Run_Payroll'
					) ||
					permissionContext.allowedPermissions.includes(
						'View_Run_Payroll'
					)
				) {
					children.push({
						key: 'run-payroll',
						icon: '',
						label: 'Run Payroll',
					});
				}
				if (
					permissionContext.allowedPermissions.includes(
						'Allow_Statutory_Components'
					)
				) {
					children.push({
						key: 'calculate-statutory',
						label: 'Calculate Statutory',
						icon: '',
					});
				}
				return children;
			};

			menuItems = pageMenuItems.map((item) => {
				if (item.key === 'time-activities-main') {
					return { ...item, children: buildTimeActivitiesChildren() };
				} else if (item.key === 'run-payroll-main') {
					return { ...item, children: buildRunPayrollChildren() };
				} else {
					return item;
				}
			});
		}
		if (
			!permissionContext.allowedPermissions.includes('Allow_Employment')
		) {
			menuItems = menuItems.filter((item) => item.key !== 'employees');
		}
		if (
			!permissionContext.allowedPermissions.includes(
				'Allow_Leave_Request'
			)
		) {
			menuItems = menuItems.filter(
				(item) => item.key !== 'leave-request'
			);
		}
		if (
			!permissionContext.allowedPermissions.includes(
				'Allow_Payroll_Reports'
			) &&
			!permissionContext.allowedPermissions.includes(
				'Allow_Attendance_Report'
			)
		) {
			menuItems = menuItems.filter((item) => item.key !== 'reports');
		}
		if (
			!permissionContext.allowedPermissions.includes(
				'Allow_Earning_and_Deduction_Reports'
			) &&
			!permissionContext.allowedPermissions.includes(
				'Allow_Payroll_Reports'
			) &&
			!permissionContext.allowedPermissions.includes(
				'Allow_Tax_Reports'
			) &&
			!permissionContext.allowedPermissions.includes(
				'Allow_Attendance_Report'
			)
		) {
			menuItems = menuItems.filter((item) => item.key !== 'reports');
		}

		const timeActivities = menuItems.find(
			(item) => item.key === 'time-activities-main'
		);
		if (timeActivities?.children?.length === 0) {
			menuItems = menuItems.filter(
				(item) => item.key !== 'time-activities-main'
			);
		}

		const payrollMenu = menuItems.find(
			(item) => item.key === 'run-payroll-main'
		);
		if (payrollMenu?.children?.length === 0) {
			menuItems = menuItems.filter(
				(item) => item.key !== 'run-payroll-main'
			);
		}

		if (permissionContext.isSuperAdmin) {
			menuItems = menuItems.filter((item) => item.key === 'dashboard');
		}

		setFinalMenuItems(menuItems);
	}, [pageMenuItems, permissionContext]);

	const [selectedSidebar, setSelectedSidebar] = useState<string>('');

	const handleSidebar = (sidebarProps: any) => {
		if (sidebarProps?.key === 'dashboard') {
			setSelectedSidebar('/');
			navigate(`/`);
		} else if (
			sidebarProps?.key === 'time-logs' ||
			sidebarProps?.key === 'monthly-summary' ||
			sidebarProps?.key === 'time-sheets' ||
			sidebarProps?.key === 'shifts' ||
			sidebarProps?.key === 'assign-supervisor' ||
			sidebarProps?.key === 'daily-attendance'
		) {
			setSelectedSidebar('time-activities-main');
			navigate(`/${sidebarProps?.key}`);
		} else if (
			sidebarProps?.key === 'mid-month' ||
			sidebarProps?.key === 'loan-request' ||
			sidebarProps?.key === 'calculate-statutory' ||
			sidebarProps?.key === 'payroll-overview' ||
			sidebarProps?.key === 'run-payroll'
			//  || sidebarProps?.key === 'payments'
		) {
			setSelectedSidebar('run-payroll-main');
			navigate(`/${sidebarProps?.key}`);
		} else {
			setSelectedSidebar(sidebarProps?.key);
			navigate(`/${sidebarProps?.key}`);
		}
	};

	const initialFunctionCall = () => {
		if (pathname === '/') {
			setSelectedSidebar('dashboard');
		} else if (
			pathname === '/reports/napsa' ||
			pathname === '/reports/nhima' ||
			pathname === '/reports/paye' ||
			pathname === '/reports/p-18' ||
			pathname === '/reports/payroll-summary' ||
			pathname === '/reports/attendance-report' ||
			pathname === '/reports/earnings' ||
			pathname === '/reports/deductions' ||
			pathname === '/reports/journal-entry' ||
			pathname === '/reports/net-pay'
		) {
			setSelectedSidebar('reports');
		} else if (pathname === '/employees') {
			setSelectedSidebar('employees');
		} else if (pathname === '/leave-request') {
			setSelectedSidebar('leave-request');
		} else if (
			pathname === '/daily-attendance' ||
			pathname === '/monthly-summary' ||
			pathname === '/time-sheets' ||
			pathname === '/shifts' ||
			pathname === '/adjust-logs'
		) {
			setSelectedSidebar('time-activities-main');
		} else if (
			pathname === '/payroll-overview' ||
			pathname === '/mid-month' ||
			pathname === '/calculate-statutory' ||
			pathname === '/loan-request' ||
			pathname === '/run-payroll'
		) {
			setSelectedSidebar('run-payroll-main');
		} else {
			setSelectedSidebar('dashboard');
		}
	};

	const [isPermissionsLoaded, setIsPermissionsLoaded] = useState(false);

	useEffect(() => {
		// Set this to true when permissions are loaded
		if (
			permissionContext.allowedPermissions.length > 0 ||
			permissionContext.isSuperAdmin
		) {
			setIsPermissionsLoaded(true);
		}
	}, [permissionContext]);

	useEffect(() => {
		if (isPermissionsLoaded) {
			initialFunctionCall();
		}
	}, [pathname, isPermissionsLoaded]);

	useEffect(() => {
		const token = localStorage.getItem('accessToken');
		if (!token) {
			navigate('/login');
			toastText('Your session has been expired, Login again!', 'error');
		}
	}, []);

	// JSX
	return !isLoading || finalMenuItems.length > 0 ? (
		<div className={styles['global-layout']}>
			<div className={styles['global-layout__wrapper']}>
				<div className={styles['global-layout__header']}>
					<Header />
				</div>
				<div className={styles['global-layout__body']}>
					<div className={styles['global-layout__body--sidebar']}>
						{isPermissionsLoaded && (
							<Sidebar
								items={finalMenuItems}
								selectedSidebar={selectedSidebar}
								handleSidebar={handleSidebar}
							/>
						)}
					</div>
					<div
						className={styles['global-layout__body--body']}
						style={{
							width: isPermissionsLoaded
								? 'calc(100vw - 200px)'
								: '100vw',
						}}
					>
						<Outlet />
					</div>
				</div>
			</div>
		</div>
	) : null;
};

export default GlobalLayout;
